import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';

export const HeroSection = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden">

      {/* Background gradient image */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/1a710595-688c-4b55-ac9a-4cf59bb327b0/images/f7e06968603df9de77087f4428bd077aa88062fc136b80685d9b0efd48c9f743.png"
          alt=""
          className="w-full h-full object-cover opacity-50" />

        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/60 to-white" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-32 pb-20 md:pt-40 md:pb-32 w-full">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-7">
          <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}>

            <span
                className="font-accent text-slate-500 mb-6 block"
                data-testid="hero-tagline">

              Instagram Growth System
            </span>
          </motion.div>

          <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 leading-[1.1] mb-6"
              data-testid="hero-headline"
              style={{ fontFamily: 'Outfit, sans-serif' }}>

            Turn Your Instagram Into a{' '}
            <span className="font-medium">Customer Machine</span>{' '}
            with <span className="font-semibold" style={{ color: '#1a3a5c' }}>BIG JAGUAR</span>
          </motion.h1>

          <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-base md:text-lg text-slate-600 leading-relaxed mb-10 max-w-xl"
              data-testid="hero-subheadline">

            We build complete Instagram growth systems for local businesses.
            No random posting. No vanity metrics. Just real customers walking
            through your door.
          </motion.p>

          <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="flex flex-col sm:flex-row gap-4">

            <button
                onClick={() => scrollTo('#contact')}
                data-testid="hero-cta-button"
                className="bg-slate-900 text-white rounded-full px-8 py-4 text-sm font-medium hover:bg-slate-800 transition-colors inline-flex items-center gap-2 group">

              Get More Customers from Instagram
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
                onClick={() => scrollTo('#results')}
                data-testid="hero-secondary-cta"
                className="text-slate-600 hover:text-slate-900 rounded-full px-8 py-4 text-sm font-medium transition-colors inline-flex items-center gap-2 border border-slate-200 hover:border-slate-300">

              <Play size={14} />
              View Case Studies
            </button>
          </motion.div>

          {/* Trust indicators */}
          <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="mt-16 flex items-center gap-8 text-sm text-slate-400"
              data-testid="hero-trust-indicators">

            <span>50+ Local Businesses</span>
            <span className="w-1 h-1 bg-slate-300 rounded-full" />
            <span>Instagram Focused</span>
            <span className="w-1 h-1 bg-slate-300 rounded-full hidden sm:block" />
            <span className="hidden sm:block">Results Guaranteed</span>
          </motion.div>
          </div>

          {/* Hero image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="hidden md:block md:col-span-5"
            data-testid="hero-image-container">

            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl shadow-slate-200/50 border border-slate-100">
                <img
                  src="https://images.unsplash.com/photo-1564758596018-3e5b1f2340cc?w=600&h=700&fit=crop"
                  alt="Restaurant owner photographing food for Instagram"
                  className="w-full h-[480px] object-cover"
                  data-testid="hero-image" />

              </div>
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-4 shadow-lg border border-slate-100">
                <p className="text-xs font-accent text-slate-400 mb-1">Avg. Customer Growth</p>
                <p className="text-2xl font-medium text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>+247%</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>);

};